/*
 * Empty search result that may be incomplete - R-20c (QA doc docs features/hotel-instant-confirmation/qa.md, C17). A hotel / tour search
 * with no offer used to become the plain error state "Data not found", which dropped providersUnavailable: the agent could not tell
 * "nothing is sold" from "a supplier did not answer". The names now ride in the empty state's load state (additionlData) and the result
 * views show the same notice there.
 */
import { DataLoadStatusModel, RequestStateModel } from '@core/store/store.models';

export const EMPTY_SEARCH_MESSAGE = 'Data not found to show. try searching with different parameters';

/** The suppliers that did not answer, as kept by {@link emptySearchResults}; empty when none. */
export const emptyResultProviders = (loadState: DataLoadStatusModel | null | undefined): string[] =>
  loadState?.additionlData?.providersUnavailable ?? [];

/**
 * The empty state of a search: the plain "Data not found" error, carrying the suppliers that did not answer. `message` replaces the plain text when the
 * search said why it found nothing (a tour search's `noResult`, processes/tour-search-and-checkout-totals.md R-NR4). `traceId` (R-NR6, C23) is the
 * search's trace id, shown as "Trace ID" under the text.
 */
export const emptySearchResults = <T>(
  providersUnavailable?: readonly string[] | null,
  message?: string,
  traceId?: string | null
): RequestStateModel<T> => {
  const loadState = new DataLoadStatusModel<{ providersUnavailable: string[] }>(
    'error',
    message ?? EMPTY_SEARCH_MESSAGE
  );
  loadState.additionlData = { providersUnavailable: [...(providersUnavailable ?? [])] };
  if (traceId) loadState.errorResponse = { activityId: traceId };
  return new RequestStateModel<T>(loadState);
};
